import { FieldOptions } from 'embed/constants'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import * as React from 'react'

const applicationFieldStyles = require('../styles')

interface Props {
  fieldOptions: FieldOptions
  tooltip?: React.ReactNode
  useFloatingLabelInputs?: boolean
}

export const FloatingLabel = ({ fieldOptions, tooltip, useFloatingLabelInputs }: Props) => {
  const { hasFloatingLabel, label } = fieldOptions
  if (!useFloatingLabelInputs) {
    return null
  }
  const hasLabel = hasFloatingLabel && label !== undefined
  return (
    <ThemeConsumer>
      {({ colorTextSecondary, fontSizeBase, labelStyles }) => (
        <>
          {hasLabel && (
            <span
              style={{ ...labelStyles, color: colorTextSecondary, fontSize: fontSizeBase }}
              className={applicationFieldStyles.floatingLabel}
            >
              {label}
            </span>
          )}
          {tooltip}
        </>
      )}
    </ThemeConsumer>
  )
}
